/* Funzione Debounce */
export function debounce(func, wait) {
    let timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}

/* Funzione SetCookie */
export function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/* Funzione GetCookie */
export function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function scroll_to(id, offset = "60", speed = "fast") {
    $("html,body").animate(
        {
            scrollTop: $("#" + id).offset().top - offset,
        },
        speed,
    );
}

export function formatMoney(value) {
    return accounting.formatMoney(value, {
        symbol: "€",
        precision: 0,
        thousand: ".",
        decimal: ",",
        format: "%s %v", // Valore prima, simbolo dopo
    });
}

export function formatMoneyAfter(value) {
    return accounting.formatMoney(value, {
        symbol: "€",
        precision: 0,
        thousand: ".",
        decimal: ",",
        format: "%v %s", // Valore prima, simbolo dopo
    });
}

// Controlla se un elemento è completamente visibile nello schermo
export function isFullyInViewport(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.bottom <= window.innerHeight;
}

// Controlla se un elemento è almeno parzialmente visibile nello schermo
export function isPartiallyInViewport(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
}
